module.exports = __webpack_public_path__ + "static/media/logo.621b0575.png";